export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/837e258702481769ad64684ae735d0c9.svg";